import { FC, memo } from 'react';
import NextImage from 'next/image';

import {
  Specifications as UISpecifications,
  SpecificationView,
} from './specifications.styles';
import { OnPlanClick } from '../planModal';
import {
  SpecificationsProps,
  SpecificationsData,
} from './specifications.types';

type RenderSpecification = (
  specification: SpecificationsData,
  onPlanClick: OnPlanClick
) => JSX.Element;

const renderSpecification: RenderSpecification = ({ id, image }, onClick) => (
  <SpecificationView key={id} onClick={() => onClick(id)}>
    <NextImage src={image} objectFit="contain" layout="fill" priority />
  </SpecificationView>
);

export const Specifications: FC<SpecificationsProps> = memo(
  ({ data, onClick }) => (
    <UISpecifications container>
      {data.map((specification) => renderSpecification(specification, onClick))}
    </UISpecifications>
  )
);
